export default (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center',
  },
  title: {
    color: '#49454F',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '27px',
    letterSpacing: 0.5,

    [theme.breakpoints.up(1024)]: {
      fontSize: 18,
    },
  },
  currenciesContainer: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  currencyChip: {},
  button: {
    maxWidth: 250,

    '& .MuiButton-root': {
      borderRadius: 16,
    },
  },
});
